import type { JSX } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

type BrowserCompatibilityDialogProps = {
  open: boolean;
  onClose: () => void;
};

export function BrowserCompatibilityDialog({ open, onClose }: BrowserCompatibilityDialogProps): JSX.Element {
  const handleClose = (_event: object, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }

    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      hideBackdrop
      fullWidth
      maxWidth="sm"
      aria-labelledby="browser-compatibility-dialog-title"
      sx={{
        zIndex: 2000,
      }}
    >
      <DialogTitle id="browser-compatibility-dialog-title" sx={{ fontWeight: 700, backgroundColor: '#ececec' }}>
        Browser compatibility
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: '#ececec', paddingTop: '20px !important' }}>
        <Typography>
          This application is designed for Google Chrome. On other browsers you may experience issues.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: '0 24px 24px', backgroundColor: '#ececec' }}>
        <Button variant="contained" className="modal-yes-btn" onClick={onClose}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
